import './jquery'
import 'bootstrap'
import 'bootstrap-table/dist/bootstrap-table.js'
import "@fortawesome/fontawesome-free/js/all.js"
import BootstrapTable from 'bootstrap-table/dist/bootstrap-table-vue.js'

import "tableexport.jquery.plugin"
import "bootstrap-table/dist/extensions/export/bootstrap-table-export.min.js"
import "bootstrap-table/dist/extensions/print/bootstrap-table-print.min.js"

import "bootstrap-table/dist/extensions/filter-control/bootstrap-table-filter-control.min.css"
import "bootstrap-table/dist/extensions/filter-control/bootstrap-table-filter-control.min.js"

export default BootstrapTable